import { BrandIdentityGuideSchema } from "@redotech/redo-agents-common/aeo-agents/brand-identity-guide";
import * as z from "zod";

export const getBrandIdentityGuide = {
  name: "getBrandIdentityGuide" as const,
  input: z.object({}),
  output: BrandIdentityGuideSchema.nullable(),
};
